var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-icon"},[_c('img',{staticClass:"app-image",attrs:{"alt":_vm.name,"src":_vm.src},on:{"click":function($event){return _vm.clickAppIcon()}}}),(_vm.nameDisplay)?_c('div',{staticClass:"app-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }